import React, { useState } from "react";
import { Box, IconButton, useTheme, useMediaQuery } from "@mui/material";
import TeacherSidebar from "../components/TeacherSidebar";
import MenuIcon from "@mui/icons-material/Menu";

export default function TeacherLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box sx={{ 
      display: "flex", 
      minHeight: "100vh",
      background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
      overflowX: 'hidden' // Prevent horizontal scrolling
    }}>
      {/* Hamburger Menu for Mobile */}
      {isMobile && (
        <IconButton
          onClick={toggleSidebar}
          sx={{
            position: "fixed",
            top: 12,
            left: 12,
            zIndex: 1200,
            background: "linear-gradient(45deg, #2c3e50, #3498db)",
            color: "white",
            border: "1px solid rgba(255,255,255,0.2)",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            "&:hover": {
              background: "linear-gradient(45deg, #34495e, #2980b9)",
              transform: "scale(1.05)",
            },
            transition: "all 0.2s ease",
            width: 42,
            height: 42,
          }}
        >
          <MenuIcon fontSize="small" />
        </IconButton>
      )}

      <TeacherSidebar 
        open={sidebarOpen} 
        onClose={() => setSidebarOpen(false)} 
        isMobile={isMobile}
      />

      <Box sx={{ 
        flexGrow: 1, 
        width: '100%', // Ensure full width
        p: { xs: 1, sm: 2, md: 3, lg: 4 }, // Reduced padding on mobile
        pt: { xs: 8, sm: 2, md: 3 }, // Adjusted top padding
        minHeight: '100vh',
        background: 'transparent',
        maxWidth: '100%', // Prevent overflow
        margin: 0, // Remove margins
        boxSizing: 'border-box', // Include padding in width calculation
      }}>
        {children}
      </Box>
    </Box>
  );
}